// import styles from "./styles.module.scss";
import LoadingButton, { LoadingButtonProps } from "@mui/lab/LoadingButton";
import classNames from "classnames";
import styles from "./styles.module.scss";

function ButtonCustom(props: LoadingButtonProps) {
  const {
    children,
    disabled,
    className,
    classes,
    color,
    variant,
    ...restProps
  } = props;
  const btnColor = styles[color || ""] || "";
  return (
    <LoadingButton
      {...restProps}
      variant={color === "info" ? "outlined" : variant}
      color={color}
      classes={{ loadingIndicator: styles.loadingIcon, ...classes }}
      disabled={disabled}
      className={classNames(styles.btn, {
        [className || ""]: !!className,
        [styles.disabled]: !!disabled,
        [btnColor]: !disabled
      })}
    >
      {children}
    </LoadingButton>
  );
}

ButtonCustom.defaultProps = {
  color: "success",
  variant: "contained",
  disableElevation: true,
  loadingPosition: "start",
  startIcon: <></>,
  size: "large"
};

export default ButtonCustom;
